import { ADeleteButton } from "@/admin/ADeleteButton.tsx";
import { AdminList } from "@/admin/AdminList.tsx";
import { AdminTable } from "@/admin/AdminTable.tsx";
import { AEditButton } from "@/admin/AEditButton.tsx";
import { machineItemFields } from "@/admin/metal/machine/machineItemFields.ts";
import { MachineItemModal } from "@/admin/metal/machine/MachineItemModal.tsx";
import { machineDeleteMutation } from "@/admin/metal/machine/machinesQuery.ts";
import { machineWithOsAtom } from "@/admin/metal/machine/machinesWithOs.ts";
import { link } from "@/components/Action.tsx";
import { WToolButton } from "@/components/button/WToolButton.tsx";
import { WModal } from "@/components/modal/WModal.tsx";
import { useStandardMutation } from "@/modules/api/useStandardMutation.ts";
import { useLocationsForType } from "@/modules/location/locationQuery.ts";
import { useSuspenseQueryAtom } from "@/utils/query/useSuspenseQueryAtom.ts";

export function MachinesView() {
    return (
        <AdminList entityType="machine" addModal={<MachineItemModal />}>
            <AdminMachinesTable />
        </AdminList>
    );
}

function AdminMachinesTable() {
    const locations = useLocationsForType("bare_metal");
    const machines = useSuspenseQueryAtom(machineWithOsAtom(locations.defaultLocation));
    const deleteMutation = useStandardMutation(machineDeleteMutation);

    return (
        <AdminTable
            items={[...machines.values()]}
            fields={machineItemFields}
            getId={(e) => e.uuid}
            actionButtons={(item) => {
                const canEdit = item.status !== "deleted";
                return (
                    <>
                        <WToolButton
                            icon="i-lucide:history"
                            inTable
                            label="History"
                            action={link({
                                to: "/admin/metal/machines/history/$location/$uuid",
                                params: { uuid: item.uuid, location: item.location },
                            })}
                        />

                        <WModal button={<AEditButton isDisabled={!canEdit} />}>
                            <MachineItemModal item={item} />
                        </WModal>
                        <ADeleteButton
                            isDisabled={!canEdit}
                            entityType="machine"
                            deleteFn={async () => await deleteMutation.mutateAsync(item)}
                        />
                    </>
                );
            }}
        />
    );
}
